import React, { Component } from 'react';
import BottomScrollListener from 'react-bottom-scroll-listener';
import { compose, graphql } from 'react-apollo';
import { withdrawalsPortal } from '../../../queries';

import Item from './Item';
import Loading from '../../../components/Loading/Page';

import Container from './styles';
import { EmptyList } from '../../../assets/styles';

class Withdrawals extends Component {
  state = {
    selected: new Map(),
    withdrawals: [],
    offset: 0,
    isLoading: false,
    hasMore: true,
  }

  componentDidMount = () => {
    this.setState({ withdrawals: this.props.withdrawals });
  }

  fetchMore = () => {
    if (this.state.hasMore) {
      this.setState(state => ({ offset: state.offset + 10, isLoading: true }));

      this.props.data.fetchMore({
        variables: {
          storeId: this.props.storeId,
          offset: this.state.offset,
          limit: 10,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (fetchMoreResult.withdrawalsPortal.length === 0) {
            this.setState({ hasMore: false, isLoading: false });

            return previousResult;
          }

          return this.setState(prevState => ({
            isLoading: false,
            withdrawals: [...prevState.withdrawals, ...fetchMoreResult.withdrawalsPortal],
          }));
        },
      });
    }
  }

  onPressItem = (id) => {
    this.setState((state) => {
      const selected = new Map(state.selected);
      selected.set(id, !selected.get(id));
      return { selected };
    });
  };

  render() {
    const { withdrawals, isLoading } = this.state;

    return (
      <Container>
        {withdrawals.length === 0 ? (
          <EmptyList>
            <p>Nenhum pagamento encontrado</p>
          </EmptyList>
        ) : (
          <>
            <div className="label">
              <div className="row">
                <h2>Data</h2>
              </div>
              <div className="row">
                <h2>Conta</h2>
              </div>
              <div className="row">
                <h2>Valor</h2>
              </div>
              <div className="row">
                <h2>Status</h2>
              </div>
              <div className="row" />
            </div>
            {withdrawals.map(item => (
              <Item
                key={item.id}
                id={item.id}
                item={item}
                onPressItem={this.onPressItem}
                selected={!!this.state.selected.get(item.id)}
              />
            ))}
            {isLoading && <Loading size={8} margin="1px" />}
            <BottomScrollListener offset={80} onBottom={this.fetchMore} />
          </>
        )}
      </Container>
    );
  }
}

export default compose(
  graphql(withdrawalsPortal, {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        storeId: props.storeId,
        offset: 0,
        limit: 10,
      },
    }),
  }),
)(Withdrawals);
